import getToken from 'lib/authentication/GetToken'

const apiHeaders = {
  getJsonData() {
    return {
      'Content-Type': 'application/json',
      accept: '*/*',
    }
  },
  getRailsData() {
    return { 'x-powered-by': 'Rails', accept: '*/*' }
  },
  noHeaderData() {
    return {
      'Content-Type': '',
      accept: '*/*',
    }
  },
  getBearerToken() {
    return {
      'x-api-token': `Bearer ${getToken()}`,
    }
  },
  noBearerToken() {
    return {
      'x-api-token': '',
    }
  },
  //TODO: other axios header configs to be added here
}

export default apiHeaders
